import {Component, inject, OnInit, signal, ChangeDetectionStrategy} from "@angular/core"
import {takeUntilDestroyed} from "@angular/core/rxjs-interop"
import {from} from "rxjs"
import {MatPaginatorModule} from "@angular/material/paginator"
import {RouterOutlet} from "@angular/router"
import {CheckboxesFilterComponent, TagSearchFilterComponent} from "@common/components/filters"
import {ItemFiltersComponent} from "@common/components/item"
import {fetchThrowingErrors} from "@common/helpers/api/fetch"
import {OrganizationsService} from "@common/services/organizations/organizations.service"
import {Labels, StateLabel} from "@labels"
import {MaterialsPageVisibleUsersGQL} from "@pages/materials/materials-page.generated"
import {JobSystemHealthComponent} from "@platform/components/jobs/job-system-health/job-system-health.component"
import {JobsTableComponent} from "@platform/components/jobs/jobs-table/jobs-table.component"
import {SidebarLayoutComponent} from "@platform/components/layouts/sidebar-layout/sidebar-layout.component"
import {IsDefined} from "@cm/utils/filter"
import {BasePageComponent} from "@pages/base/base-page.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-jobs-page",
    imports: [
        CheckboxesFilterComponent,
        ItemFiltersComponent,
        MatPaginatorModule,
        RouterOutlet,
        TagSearchFilterComponent,
        JobSystemHealthComponent,
        JobsTableComponent,
        SidebarLayoutComponent,
    ],
    templateUrl: "./jobs-page.component.html",
    styleUrl: "./jobs-page.component.scss",
})
export class JobsPageComponent extends BasePageComponent implements OnInit {
    readonly organizations = inject(OrganizationsService)

    readonly visibleUsersGql = inject(MaterialsPageVisibleUsersGQL)

    readonly $userLabels = signal<StateLabel<string>[] | null>(null)

    override ngOnInit() {
        super.ngOnInit()
        from(fetchThrowingErrors(this.visibleUsersGql)({}))
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(({users}) => {
                this.$userLabels.set(
                    users.filter(IsDefined).map((user) => ({
                        label: user.name,
                        state: user.id,
                    })),
                )
            })
    }

    public readonly Labels = Labels
}
